import { render, staticRenderFns } from "./release.vue?vue&type=template&id=7c28902f&scoped=true&"
import script from "./release.vue?vue&type=script&lang=ts&"
export * from "./release.vue?vue&type=script&lang=ts&"
import style0 from "./release.vue?vue&type=style&index=0&id=7c28902f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c28902f",
  null
  
)

export default component.exports